import jobsRotas from './jobs/JobsRotas'
import ParametrosRotas from './parametros/ParametrosRotas'

export default {
    path: 'admin',
    name: 'Admin',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [jobsRotas, ParametrosRotas]
}
